var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pict',{attrs:{"block-name":"wave-hero","default":{
    src: _vm.$options.image[_vm.$i18n.locale].l,
    srcset: {
      '2x': _vm.$options.image[_vm.$i18n.locale].l2x
    }
  },"sources":[
    {
      media: 's',
      src: _vm.$options.image[_vm.$i18n.locale].xs,
      srcset: {
        '2x': _vm.$options.image[_vm.$i18n.locale].xs2x
      }
    }
  ],"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }